module.exports = __webpack_public_path__ + "img/baht-green.117ba125.png";